import type { Event } from "@sentry/types";

let enableErrors = true;

const turnOffErrorReporting = () => {
  enableErrors = false;
};

const errorsTurnedOffFilter = (event: Event): Event | null => {
  if (enableErrors) return event;

  return null;
};

export { errorsTurnedOffFilter, turnOffErrorReporting };
